import React from 'react';

const SupportHelp: React.FC = () => {
  return (
    <>
      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Support
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          The Support page helps you manage support tickets. Clients can create
          tickets to request help, while partners can view and respond to their
          clients' tickets.
        </p>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Ticket Statistics
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          The top section shows ticket counts by status:
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li><strong>Open:</strong> New tickets awaiting response</li>
          <li><strong>In Progress:</strong> Tickets being actively worked on</li>
          <li><strong>Resolved:</strong> Tickets that have been addressed</li>
          <li><strong>Closed:</strong> Completed tickets</li>
        </ul>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Creating Tickets (Clients)
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          If you're a client, click "New Ticket" to submit a support request:
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li><strong>Subject:</strong> Brief description of the issue</li>
          <li><strong>Type:</strong> Technical, Billing, General, Feature Request, or Bug Report</li>
          <li><strong>Priority:</strong> Low, Medium, High, or Critical</li>
          <li><strong>Description:</strong> Detailed explanation of your request</li>
        </ul>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Managing Tickets (Partners)
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          Partners can manage their clients' tickets:
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li>View all tickets from your clients</li>
          <li>Reply to tickets with updates or solutions</li>
          <li>Change ticket status (Open → In Progress → Resolved → Closed)</li>
          <li>Filter by status and priority</li>
        </ul>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Filtering & Search
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          Find tickets quickly:
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li>Click status tabs to filter (All, Open, In Progress, etc.)</li>
          <li>Use the priority dropdown to filter by urgency</li>
          <li>Search by ticket subject, description, or requester name</li>
        </ul>
      </div>

    </>
  );
};

export default SupportHelp;
